import { useRouter } from 'next/router'
import { useEffect } from 'react'

export function usePageReloader() {
    const router = useRouter()
    useEffect(() => {
        sessionStorage.setItem('open-page', Date.now().toString())
        const timerId = setInterval(() => {
            let openPageDateStr = sessionStorage.getItem('open-page')

            if (!openPageDateStr) {
                const time = Date.now().toString()
                openPageDateStr = time
                sessionStorage.setItem('open-page', time)
            }
            const openPageDateTime = new Date(parseInt(openPageDateStr))
            const differentMs = Date.now() - openPageDateTime.getTime()
            const diffTotalMinutes = new Date(differentMs).getMinutes()
            if (diffTotalMinutes > 20) router.reload()
        }, 60 * 1000)
        return () => {
            clearInterval(timerId)
        }
    }, [])
}
